import ElementVisibilityToggleController from "controllers/element_visibility_toggle_controller"

export default class extends ElementVisibilityToggleController {
  // NOTE: When defining the index of the element to toggle on, make sure that when your model has a nil value,
  // the index will be the same size as the length because of the extra empty row that slim select adds
  // When you have an existing value, the index will be length - 1

  static values = { index: String }

  toggle(event) {
    if (parseInt(event.target.options.selectedIndex) === parseInt(this.indexValue)) {
      this.toggleOn()
    } else {
      this.toggleOff()
    }
  }
}
